meedy.factory('meedy.passwordModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.passwordService',
    function($rootScope, applicationModel, baseModel, passwordService) {

        function PasswordModel() {

            this.changePassword = function(oldPassword, newPassword) {
                passwordService.changePassword(oldPassword, newPassword).then(
                    function (list) {
                        baseModel.broadcastOperationSucceeded();
                        $rootScope.$broadcast(Event.MEEDY.PASSWORD.CHANGE_PASSWORD.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.PASSWORD.CHANGE_PASSWORD.ERROR, error);
                    }
                );
            };

        }

        return new PasswordModel();
    }
]);
